import { globalStyles } from "common/theme/styles";
const colors = globalStyles.colors;

const statusColors = {
    Failed: colors.errorText,
    InProgress: colors.cta['100'],
    Completed: colors.succesColor,
    Success: colors.succesColor
};

export const getStatusColor = (status) => `${statusColors[status] || colors.text['200']} !important`;

export const statusData = [
    {
        name: "Completed",
        value: "completed",
        color: "#01b574",
    },
    {
        name: "To Do",
        value: "todo",
        color: "#3965ff",
    },
    {
        name: "On Hold",
        value: "onHold",
        color: "#ee5d50",
    },
    {
        name: "In Progress",
        value: "inProgress",
        color: "#805ad5",
    },
    {
        name: "Pending",
        value: "pending",
        color: "#a37f08",
    },
];